import { render, staticRenderFns } from "./ModalRename.vue?vue&type=template&id=beb66930"
import script from "./ModalRename.vue?vue&type=script&lang=js"
export * from "./ModalRename.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports